import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsPrechecked extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsPrechecked: "/api/v1/portal/jobs/mark-as/toggle/prechecked/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  toggleMarkJobAsPrechecked() {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsPrechecked+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }

  render() {
    return(
      <span> {(this.state.data.prechecked === 1) ?
        <p><button className="btn btn-lg row-status-bg-prechecked">
          Job Prechecked (by {this.state.data.marked_as_prechecked_by.first_name
        }&nbsp;{this.state.data.marked_as_prechecked_by.last_name} on {
          this.state.data.marked_as_prechecked_at
        })
        </button>&nbsp;
          <button
            className="btn btn-lg btn-dark"
            title={"Toggle Mark Job as: Prechecked"}
            onClick={(e) => this.toggleMarkJobAsPrechecked(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job As Prechecked
          </button></p>
        :
        <p>Job Not Prechecked<br />
        <button
        className="btn btn-lg btn-dark"
        title={"Toggle Mark Job as: PreChecked"}
        onClick={(e) => this.toggleMarkJobAsPrechecked(e)}
        >
        Mark Job As Prechecked
        </button>
        </p>
      }
    </span>
    )
  }
}